import { Injectable, Injector } from '@angular/core';
import { Http, Headers, Response } from '@angular/http';

import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/toPromise';
import { ToasterUtilService } from '../util/toaster-util.service';
import { LoginModel } from '../routes/login/login.model';
import { SessaoModel } from '../util/model/sessao.model';
import { HttpParams } from '@angular/common/http';
import { Select2OptionData } from 'ng2-select2';
import { UtilService } from '../util/util.service';
import { AlterarSenhaAuxModel } from '../util/model/alterar-senha-aux.model';
import { TokenModel } from '../util/model/token.model';
import { RetornoValidacaoModel } from '../util/model/retorno-validacao.model';
import { SessaoUtil } from '../util/sessao-util';


@Injectable()
export class AutenticacaoService {

  private self:any;
  // URL padrao sistema ./
  private url: string = UtilService.getUrl();

  constructor(private http: Http,  
            private toasterUtil: ToasterUtilService,
        ) {
    this.self = this;
  }

  getHeadersComAuthorization(token: string): Headers {
    let retorno: Headers = new Headers();

    retorno.append('Content-Type', 'application/json');
    retorno.append('Accept', 'application/json');
    retorno.append('Authorization', 'Bearer ' + token);

    return retorno;
  }

  getHeaders(): Headers {
    let retorno: Headers = new Headers();

    retorno.append('Content-Type', 'application/json');
    retorno.append('Accept', 'application/json');

    return retorno;
  }


  retornaEmpresas(): Promise<Array<Select2OptionData>> {
    return this.http.get(UtilService.getUrlAutenticacao() + 'oauth/empresas')
                    .toPromise()
                    .then((response: Response) => {
                        this.handleMessage(response.headers);
                        return response.json();
                    })
                    .catch(this.handleError);
  }

  getFormUrlEncoded(toConvert) {
		const formBody = [];
		for (const property in toConvert) {
			const encodedKey = encodeURIComponent(property);
			const encodedValue = encodeURIComponent(toConvert[property]);
			formBody.push(encodedKey + '=' + encodedValue);
		}
		return formBody.join('&');
	}

  login(login: LoginModel): Promise<any> {

    let body = {'client': 'angular.backup@ats',
                'username': login.login,
                'password': login.senha,
                'grant_type': 'password'};

    let headers: Headers = new Headers();

    headers.append('Content-Type', 'application/x-www-form-urlencoded');

    headers.append('Authorization', "Basic " + btoa("angular.backup@ats:Ats@3875"));

    return this.http.post(UtilService.getUrlAutenticacao() + 'oauth/token',  this.getFormUrlEncoded(body), { headers: headers})
                    .toPromise()
                    .then((resp) => {
                        this.handleMessage(resp.headers);
                        return resp.json();
                    })
                    .catch(this.handleError.bind(this))
  }

  logoff(token : TokenModel): Promise<Boolean> {

    let tJSON = JSON.stringify(token);

    return this.http.post(UtilService.getUrlAutenticacao() + 'oauth/logoff', tJSON, {headers : this.getHeaders()})
                .toPromise()
                .then((response: Response) => {
                    this.handleMessage(response.headers);
                    return (response.status == 200);
                })
                .catch(this.handleError.bind(this));
  }

  tokenValid(token : TokenModel): Promise<Boolean> {

    let tJSON = JSON.stringify(token);

    return this.http.post(UtilService.getUrlAutenticacao() + 'oauth/validToken', tJSON, {headers : this.getHeaders()})
                .toPromise()
                .then((response: Response) => {
                    this.handleMessage(response.headers);
                    return response.json();
                })
                .catch(this.handleError.bind(this));
  }

  validaUsuario(login: LoginModel): Promise<RetornoValidacaoModel> {
    let tJSON = JSON.stringify(login);

    return this.http.post(UtilService.getUrlAutenticacao() + 'oauth/validaUsuario', tJSON, {headers : this.getHeaders()})
                .toPromise()
                .then((response: Response) => {
                    this.handleMessage(response.headers);
                    return response.json();
                })
                .catch(this.handleError.bind(this));
  }

  validaUsuarioTemporario(login: LoginModel): Promise<LoginModel> {
    let tJSON = JSON.stringify(login);

    return this.http.post(UtilService.getUrlAutenticacao() + 'oauth/validaUsuarioTemporario', tJSON, {headers : this.getHeaders()})
                .toPromise()
                .then((response: Response) => {
                    this.handleMessage(response.headers);
                    return response.json();
                })
                .catch(this.handleError.bind(this));
  }

  montaSessaoUsuario(login: LoginModel, token : string): Promise<SessaoModel> {
    let tJSON = JSON.stringify({login: login.login});

    return this.http.post(UtilService.getUrlAutenticacao() + 'oauth/montaSessaoUsuario', tJSON, {headers : this.getHeadersComAuthorization(token)})
                .toPromise()
                .then((response: Response) => {
                    this.handleMessage(response.headers);
                    return response.json();
                })
                .catch(this.handleError.bind(this));
  }

  montaSessaoUsuarioTemporario(login: LoginModel, token : string): Promise<SessaoModel> {
    let tJSON = JSON.stringify({loginTemporario: login.login});

    return this.http.post(UtilService.getUrlAutenticacao() + 'oauth/montaSessaoUsuarioTemporario', tJSON, {headers : this.getHeadersComAuthorization(token)})
                .toPromise()
                .then((response: Response) => {
                    this.handleMessage(response.headers);
                    return response.json();
                })
                .catch(this.handleError.bind(this));
  }

  private handleError(error: any): Promise<any> {
        let errMsg: string;
        if (error instanceof Response) {
            const body = error.json() || '';
            const err = body.messages || JSON.stringify(body);
            if(body.error != undefined && body.error == "invalid_grant"){
              errMsg = 'Login/E-Mail ou senha inválidos.';
              return null;
            }else{
              errMsg = `${err}`;
            }
        } else {
            errMsg = error.messages ? error.messages : error.toString();
        }
        console.error(errMsg);
        return Promise.reject(errMsg);
    }

    private handleMessage(header: Headers) {
        if (header == null || header == undefined) {
            return;
        }
        let emissorMessage = header.toJSON();
        if (emissorMessage != undefined && emissorMessage != null) {
            let arrayMessage = emissorMessage['MessageEmissorNF'];
            if (arrayMessage != null && arrayMessage != undefined && arrayMessage.lenght > 0) {
                let causaString = arrayMessage[0];
                let causaJSON = decodeURIComponent(causaString);
                let causaArray = JSON.parse(causaJSON);
                for(let i = 0; i < causaArray.length; i++) {
                    if (causaArray[i].tipo == 'INFO') {
                        this.toasterUtil.info(causaArray[i].msg);
                    }
                    if (causaArray[i].tipo == 'WARN') {
                        this.toasterUtil.alerta(causaArray[i].msg);
                    }
                    if (causaArray[i].tipo == 'ERRO' || causaArray[i].tipo == 'FATAL') {
                        this.toasterUtil.erro(causaArray[i].msg);
                    }
                }
            }
        }
    }

}



// WEBPACK FOOTER //
// ./src/app/service/autenticacao.service.ts